import React from 'react'
import { isRtl } from 'src/helper/tool'

import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    const { lang, language, isRedPoint, active } = this.props
    return (
      <div className={`nav-wrap ${isRtl(language) ? 'arlang' : ''}`}>
        {
          isRtl(language) ? (
            <div
              className={`nav-item ${this.props.active === 0 ? 'active' : ''} ${language} ${isRedPoint ? 'red-point' : ''}`}
              data-index={active}
              onClick={() => this.props.onSlideTo(0)}
              dangerouslySetInnerHTML={{ __html: lang.cheer_rewards }}
            >
            </div>
          ) : (
            <div
              className={`nav-item ${this.props.active === 0 ? 'active' : ''}`}
              data-index={active}
              onClick={() => this.props.onSlideTo(0)}
            >
              {lang.global_star}
            </div>
          )
        }
        <div
          className={`nav-item ${this.props.active === 1 ? 'active' : ''}`}
          data-index={active}
          onClick={() => this.props.onSlideTo(1)}
        >
          {lang.national_star}
        </div>
        {
          isRtl(language) ? (
            <div
              className={`nav-item ${this.props.active === 2 ? 'active' : ''}`}
              data-index={active}
              onClick={() => this.props.onSlideTo(2)}
            >
              {lang.global_star}
            </div>
          ) : (
            <div
              className={`nav-item ${this.props.active === 2 ? 'active' : ''} ${language} ${isRedPoint ? 'red-point' : ''}`}
              data-index={active}
              onClick={() => this.props.onSlideTo(2)}
              dangerouslySetInnerHTML={{ __html: lang.cheer_rewards }}
            >
            </div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/tab-nav/index.js